module.exports = __webpack_public_path__ + "static/media/cog_black.fc9dfeae.svg";